import { DoctorSpecialty } from '@dreryk/egabinet-personnel-frontend-api';
import { Practitioner } from '@dreryk/egabinet-waitlist-frontend-api';

export const formatPractitioner = (
   practitioner: Omit<Practitioner, 'id'> & { doctorSpecialties?: DoctorSpecialty[] }
): string => {
   const mainSpecialty = practitioner.doctorSpecialties?.find(({ main }) => main);
   const fullName = `${practitioner.lastName.asString()} ${practitioner.firstName.asString()}`;

   if (mainSpecialty) {
      return `${fullName}, ${mainSpecialty.medicalSpecialty.name}`;
   }

   return fullName;
};
